export interface IAfterSaleWarrantySnapshot {
  exchangePeriod: number
  returnRefundPeriod: number
  warrantyPeriod: number
  // noReasonReturnRefund 7天无理由退货 string[] 类型时的值为支持7天无理由退货的物流类型
  // { days: number, isSupport: number | boolean } 类型时 days为天数 isSupport为是否支持7天无理由
  noReasonReturnRefund?: {
    days: number
    isSupport: number | boolean
  } | string[]
  canExchangeSku?: boolean
}

export interface IWarrantyTagsRow {
  completedTime: string
  warrantySnapshot?: IAfterSaleWarrantySnapshot
}

export interface IWarrantyTagsResult {
  tags: string[]
  serviceArr: string[]
}

export interface IWarrantyTagsOptions {
  completedTime?: string
  logisticsType?: string
}

type WarrantyPeriodKey = 'warrantyPeriod' | 'returnRefundPeriod' | 'exchangePeriod' | 'noReasonReturnRefund'
type WarrantyConfigItem =
  | { key: WarrantyPeriodKey, name: string, detailName?: string }

const afterSaleWarrantyConfig: WarrantyConfigItem[] = [
  {
    key: 'warrantyPeriod',
    name: 'Warranty',
    detailName: 'Support',
  },
  {
    key: 'returnRefundPeriod',
    name: 'Return & Refund',
    detailName: 'Return'
  },
  {
    key: 'exchangePeriod',
    name: 'New Replace',
    detailName: 'Exchange'
  },
  {
    key: 'noReasonReturnRefund',
    name: 'No-Reason Return',
    detailName: 'Free Returns'
  }
]

const formatWarrantyPeriod = (days: number, label: string | undefined): string => {
  // TODO: 当前不进行时间单位转换，具体显示规则确认前直接显示天数。
  return `${days}-Day ${label}`
}

export const getWarrantyTagsBySnapshot = (
  warrantySnapshot?: IAfterSaleWarrantySnapshot,
  options: IWarrantyTagsOptions = {},
  isDetail?: boolean
): IWarrantyTagsResult => {
  if (!warrantySnapshot) {
    return {
      tags: [],
      serviceArr: []
    }
  }

  const { completedTime, logisticsType } = options
  const diffDay = completedTime
    ? Math.ceil(
      (new Date().getTime() - new Date(completedTime).getTime()) /
        (1000 * 60 * 60 * 24)
    )
    : 0
  const tags: string[] = []
  const serviceArr: string[] = []

  // 是否允许更换sku不需要进行tag显示,只是作为换货申请时是否能换sku的依据
  warrantySnapshot.canExchangeSku && serviceArr.push('canExchangeSku')
  const noReasonReturnRefund = warrantySnapshot.noReasonReturnRefund
  let days = 0
  let isNoReason = false // 是否支持7天无理由
  if (Array.isArray(noReasonReturnRefund)) {
    days = 7
    isNoReason = Boolean(
      logisticsType &&
      noReasonReturnRefund.some(item => item.toLowerCase() === logisticsType.toLowerCase())
    )
  } else if (noReasonReturnRefund) {
    days = noReasonReturnRefund.days
    isNoReason = Boolean(noReasonReturnRefund.isSupport)
  }
  afterSaleWarrantyConfig.forEach((item) => {
    const name = isDetail ? item.detailName : item.name || ''
    if (item.key === 'noReasonReturnRefund') {
      if (isNoReason && days && diffDay <= days) {
        tags.push(formatWarrantyPeriod(days, name))
        serviceArr.push(item.key)
      }
      return
    }
    const value = warrantySnapshot[item.key]
    // 支持7天无理由且质保期小于7天,则显示7天无理由,否则显示质保期
    if (value && diffDay <= value && (isNoReason && value >= 7 || !isNoReason)) {
      tags.push(formatWarrantyPeriod(value, name))
      serviceArr.push(item.key)
    }
  })

  return {
    tags,
    serviceArr
  }
}

export const getWarrantyTags = (row: IWarrantyTagsRow): IWarrantyTagsResult => {
  return getWarrantyTagsBySnapshot(
    row.warrantySnapshot,
    { completedTime: row.completedTime }
  )
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      getWarrantyTags,
      getWarrantyTagsBySnapshot
    }
  }
})
